const MAP_DATA = {
  da: {
    PLACE_ID: 'ChIJe0V2qxFTUkYRhQjBW9qq9hU',
    LAT: 55.6786789,
    LNG: 12.5743981,
  },
  fr: {
    PLACE_ID: 'ChIJ6a3azR5u5kcR_aOG3YjgTBo',
    LAT: 48.8609238,
    LNG: 2.3483756,
  },
  nb: {
    PLACE_ID: 'ChIJQQUa0_xtQUYRZyrJmj1pL2M',
    LAT: 59.9483643,
    LNG: 10.7333938,
  },
  sv: {
    PLACE_ID: 'EiZTdmVhdsOkZ2VuIDIsIDExMSA1NyBTdG9ja2hvbG0sIFN3ZWRlbiJQEk4KNAoyCXXkXthdnV9GEbNwjIL3V8BiGh4LEO7B7qEBGhQKEgmBJQecXZ1fRhHjHD4X8_4ACwwQAioUChIJ3yuaF2-dX0YRAMFdlSaIuc0',
    LAT: 59.33318429589132,
    LNG: 18.06509267104066,
  },
};

export default MAP_DATA;
